class conceptos {
  constructor(
    conceptId,
    name,
    fullDayLicense,
    workHours,
    roundSalary,
    cat,
    ws,
    denyAccess
  ) {
    this.conceptId = conceptId;
    this.id = conceptId;
    this.name = name;
    this.fullDayLicense = fullDayLicense;
    this.fullDayLicenseTable = this.fullDayLicense === "S" ? "✔️" : "";
    this.workHours = workHours;
    this.workHoursTable = this.workHours === "S" ? "✔️" : "";
    this.roundSalary = roundSalary;
    this.roundSalaryTable = this.roundSalary === true ? "✔️" : "";
    this.cat = cat;
    this.ws = ws;
    this.denyAccess = denyAccess;
    this.id = conceptId;
  }
  static fromJson({
    conceptoId,
    nombre,
    licTot,
    horTrab,
    redondeaLiq,
    cat,
    ws,
    denegarAcceso,
  }) {
    return new conceptos(
      conceptoId,
      nombre,
      licTot,
      horTrab,
      redondeaLiq,
      cat,
      ws,
      denegarAcceso
    );
  }
}
export default conceptos;
